var app = angular.module('leonardo');

var FilterSelector = function($filter, $timeout, $state, FilterService) {
  return {
    restrict: 'A',
    templateUrl: 'views/templates/widget/filter-selector.html',
    scope: {
      filters: '=',
      inline: '=',
      placeholder: '@',
      label: '@',
      filter: '@'
    },
    link: function (scope, element, attrs) {
      scope.filters_options_object = [];
      scope.filters_options = [];
      scope.filters_groups = [];
      scope.filters_value = {};
      scope.filter = scope.filter ? scope.filter : 'filters';
      scope.filters_active = FilterService.hasFilter(scope.filter) ? FilterService.getFilter(scope.filter) : [];
      scope.initState = $state.current.url;

      scope.initialized = false;
      scope.groups = false;

      scope.getGroup = function(group) {
        var result = null;
        angular.forEach(scope.filters_groups, function (option) {
          if (option.group === group) {
            result = option;
          }
        });
        return result;
      };

      scope.initGroups = function(options) {
        scope.filters_groups = [];
        angular.forEach(options, function (option) {
          if (option && option.elements) {
            var elements = [];
            angular.forEach(option.elements, function(value) {
              if (value && !isNull(value.condition)){
                if (angular.isFunction(value.condition)) {
                  if (value.condition()) {
                    elements.push(value);
                  }
                }
                else if (value.condition) {
                  elements.push(value);
                }
              }
            });
            option.elements = elements;
            scope.filters_groups.push(option);
          }
          else {
            if (!scope.getGroup('default')) {
              scope.filters_groups.push({
                group: 'default',
                name: 'By Others',
                elements: []
              });
            }
            if (!isNull(option.condition)){
              if (angular.isFunction(option.condition)) {
                if (option.condition()) {
                  scope.getGroup('default').elements.push(option);
                }
              }
              else if (option.condition) {
                scope.getGroup('default').elements.push(option);
              }
            }
          }
        });
      };

      scope.parseOptions = function (options) {
        var results = [];
        scope.groups = false;
        if (angular.isArray(options) && options.length > 0) {
          angular.forEach(options, function (option) {
            if (option && option.elements) {
              angular.forEach(option.elements, function (elm) {
                if (!isNull(elm && elm.condition)){
                  if (angular.isFunction(elm.condition)) {
                    if (elm.condition()) {
                      results.push(elm);
                      scope.groups = true;
                    }
                  }
                  else if (elm.condition) {
                    results.push(elm);
                    scope.groups = true;
                  }
                }
              });
            }
            else {
              if (!isNull(option.condition)){
                if (angular.isFunction(option.condition)) {
                  if (option.condition()) {
                    results.push(option);
                  }
                }
                else if (option.condition) {
                  results.push(option);
                }
              }
            }
          });
        }
        else {
          if (!isNull(options)) {
            results = !angular.isArray(options) ? options.split(',') : [];
          }
          else {
            results = options;
          }
        }
        return results;
      };

      scope.initOptions = function() {
        scope.filters_value = {};
        scope.filters_options = scope.parseOptions(scope.filters);
        angular.forEach(scope.filters_options, function(value) {
          scope.filters_value[value.id] = FilterService.hasFilter(value.id) ? FilterService.getFilter(value.id) : null;
        });
        if (scope.groups) {
          scope.initGroups(scope.filters);
          scope.filters_options_object = scope.filters_groups;
        }
        else {
          scope.filters_options_object = scope.filters_options;
        }
        scope.initialized = true;
      };

      scope.isActive = function(filter_id) {
        return scope.filters_active.includes(filter_id);
      };

      scope.getFilter = function(filter_id) {
       var filter = null;
       angular.forEach(scope.filters_options, function(elm) {
         if (elm.id === filter_id) {
           filter = elm;
         }
       });
       return filter;
      };

      scope.getFiltersActive = function() {
        var results = [];
        angular.forEach(scope.filters_active, function (filter_id) {
          var filter = scope.getFilter(filter_id);
          if (filter) {
            if (filter.required) {
              results.unshift(filter_id);
            }
            else {
              results.push(filter_id);
            }
          }
        });
        return results;
      };

      scope.showFilter = function(type, filter_id) {
        var filter = scope.getFilter(filter_id);
        return !isNull(filter) ? filter.type === type : false;
      };

      scope.getPlaceholder = function (filter_id) {
        var filter = scope.getFilter(filter_id);
        var placeholder = (!isNull(filter) && filter.placeholder) ? $filter('translate')(filter.placeholder) : '';
        if (!placeholder && !isNull(filter)) {
          switch (filter.type) {
            case 'options':
              placeholder = $filter('translate')('Select ' + filter.name);
              break;
            case 'text':
              placeholder = $filter('translate')(filter.name);
              break;
          }
        }
        return placeholder;
      };

      scope.closeFilter = function(filter_id) {
        var required = false;
        var filters = angular.copy(scope.filters_active);
        if (!isNull(filters) && filters.length > 0) {
          angular.forEach(scope.filters_options, function(option) {
            if (_.contains(filters, option.id) && (option.type === "date_range")) {
              if ((filter_id === option.startDate) || (filter_id === option.endDate)) {
                required = true;
              }
            }
          });
          if (!required) {
            angular.forEach(filters, function(filter, key) {
              if (filter === filter_id) {
                filters.splice(key, 1);
                scope.closing = true;
                FilterService.removeFilter(filter_id);
              }
            });
          }
        }
        scope.filters_active = filters;
        FilterService.setFilter(scope.filter, !isNull(filters) ? filters.join(',') : filters);
        scope.filters_value[filter_id] = null;
      };

      scope.resolveConflicts = function() {
        var filters_active_aux = angular.copy(scope.filters_active);
        var filters_conflicts = [];
        if (!isNull(scope.filters_active) && scope.filters_active.length > 0) {
          var last_filter = scope.getFilter(scope.filters_active[scope.filters_active.length-1]);
          if (!isNull(last_filter) && !isNull(last_filter.conflicts)) {
            var conflicts = angular.isArray(last_filter.conflicts) ?
              last_filter.conflicts : last_filter.conflicts.split(',');
            if (conflicts.length > 0) {
              filters_active_aux = [];
              angular.forEach(scope.filters_active, function(filter) {
                var filter_element = scope.getFilter(filter);
                var conflicts_element = angular.isArray(filter_element.conflicts) ?
                  filter_element.conflicts : filter_element.conflicts.split(',');
                if (!isNull(filter_element) &&
                  !_.contains(conflicts, filter_element.id) &&
                  !_.contains(conflicts_element, last_filter.id)) {
                  filters_active_aux.push(filter);
                }
                else {
                  filters_conflicts.push(filter);
                }
              });
            }
          }
        }
        scope.filters_active = filters_active_aux;
        FilterService.setFilter(scope.filter, !isNull(filters_active_aux) ? filters_active_aux.join(',') : filters_active_aux);
        angular.forEach(filters_conflicts, function(filter) {
          FilterService.removeFilter(filter);
          scope.filters_value[filter] = null;
        });
      };

      scope.submit = function(filter_id) {
        var filter = scope.getFilter(filter_id);
        if (!isNull(filter) && !isNull(filter.onSubmit)) {
          filter.onSubmit();
        }
      };

      scope.$watch('filters_active', function (newValue, oldValue) {
        if (!angular.equals(newValue,oldValue)) {
          var filters_active = angular.copy(newValue);
          angular.forEach(scope.filters_options, function(option) {
            if (_.contains(newValue, option.id) && (option.type === "date_range")) {
              if (!_.contains(filters_active, option.startDate)) {
                filters_active.push(option.startDate);
              }
              if (!_.contains(filters_active, option.endDate)) {
                filters_active.push(option.endDate);
              }
            }
            if (_.contains(newValue, option.id) && (option.type === 'checkbox')) {
              if (!FilterService.hasFilter(option.id)) {
                FilterService.setFilter(option.id, false);
              }
            }
          });
          if (!angular.equals(filters_active, newValue)) {
            scope.filters_active = filters_active;
          }
          scope.resolveConflicts();
        }
      });

      scope.$on('filter-service:filter-changed', function ($event, key, value) {
        if (key === scope.filter) {
          var filters = angular.isArray(value) ? value : value.split(',');
          angular.forEach(scope.filters_options, function(filter) {
            if (!_.contains(filters, filter.id) && !isNull(scope.filters_value[filter.id])) {
              FilterService.removeFilter(filter.id);
              scope.filters_value[filter.id] = null;
            }
          });
        }
        angular.forEach(scope.filters_options, function(filter) {
          if (key === filter.id) {
            $timeout(function() {
              scope.initOptions();
            }, 100);
          }
        });
      });

      scope.$on('filter-service:filter-removed', function ($event, key) {
        if (key === scope.filter) {
          angular.forEach(scope.filters_options, function(filter) {
            FilterService.removeFilter(filter.id);
            scope.filters_value[filter.id] = null;
          });
        }
        angular.forEach(scope.filters_options, function(filter) {
          if (key === filter.id) {
            $timeout(function() {
              scope.initOptions();
            }, 100);
          }
        });
      });

      scope.$watch('filters', function (newValue, oldValue) {
        if (!angular.equals(newValue,oldValue) || !scope.initialized) {
          scope.initOptions();
        }
      });

      scope.$on('no_reset_filters:updated', function(event, value) {
        scope.no_reset_filters = value;
      });

      scope.$on('$destroy', function () {
        if (!scope.no_reset_filters && (scope.initState !== $state.current.url)) {
          FilterService.clearFilters(true, null, scope.filter);
        }
      });

    }
  };
};

app.directive('filterSelector', ['$filter', '$timeout', '$state', 'FilterService', FilterSelector]);
